import { Card, CardContent } from "@simurgh/feathers/ui/card";
import { Skeleton } from "@simurgh/feathers/ui/skeleton";

export function FlashcardSkeleton() {
	return (
		<div className="flex flex-col justify-between min-h-[95vh] gap-4">
			{/* Header with back button and progress */}
			<div className="flex items-center gap-2">
				<Skeleton className="h-10 w-10 rounded" />
				<div className="flex-1 flex gap-1">
					{Array.from({ length: 5 }).map((_, index) => (
						<Skeleton key={index} className="h-1 flex-1 rounded-full" />
					))}
				</div>
			</div>

			{/* Flashcard container */}
			<Card className="flex-1 max-w-[720px] mx-auto w-full">
				<CardContent className="p-8 space-y-6">
					{/* Audio controls */}
					<div className="flex items-center justify-center gap-4">
						<Skeleton className="h-12 w-12 rounded-full" />
						<Skeleton className="h-10 w-10 rounded-full" />
					</div>

					{/* Main word/title */}
					<div className="text-center space-y-2">
						<Skeleton className="h-10 w-48 mx-auto" />
						<Skeleton className="h-6 w-32 mx-auto" />
					</div>

					{/* Metadata chips */}
					<div className="flex justify-center gap-2">
						<Skeleton className="h-6 w-20 rounded-full" />
						<Skeleton className="h-6 w-24 rounded-full" />
						<Skeleton className="h-6 w-16 rounded-full" />
					</div>

					{/* Content area */}
					<div className="space-y-4 pt-4">
						<Skeleton className="h-5 w-full" />
						<Skeleton className="h-5 w-5/6" />
						<Skeleton className="h-5 w-4/5" />
						<div className="pt-4">
							<Skeleton className="h-4 w-full" />
							<Skeleton className="h-4 w-3/4 mt-2" />
						</div>
					</div>
				</CardContent>
			</Card>

			{/* Action buttons */}
			<div className="w-full max-w-[720px] mx-auto space-y-4">
				<div className="flex justify-center">
					<Skeleton className="h-12 w-48 rounded-full" />
				</div>
			</div>
		</div>
	);
}
